import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "main",
    component: () => import("@/views/MainView.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/procurementsRules",
    name: "procurementsRules",
    component: () => import("@/views/ProcurementRulesView.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/procurementsRules/:id/versions",
    name: "procurementsRulesVersions",
    component: () => import("@/views/ProcurementRulesVersionsView.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/procurementsRules/:procId/versions/:id/documentsRules",
    name: "documentsRules",
    component: () => import("@/views/DocumentsRulesView.vue"),
    meta: { requiresAuth: true, requresAdminOrSpecialistOrOperator: true }
  },
  {
    path: "/files/:id",
    name: "files",
    component: () => import("@/views/ProcurementDocumentsView.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/procurement_documents/:id",
    name: "procurement_documents",
    component: () => import("@/views/NewProcorementDocumentationView.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/eisPlanItems/:number",
    name: "eisPlanItems",
    component: () => import("@/views/EisPlanItemsView.vue"),
    meta: { requiresAuth: true },
    props: true
  },
  {
    path: "/users",
    name: "users",
    component: () => import("@/views/UsersView.vue"),
    meta: { requiresAuth: true, requresAdminOrSpecialistOrOperator: true }
  },
  {  
    path: "/documents",
    name: "documents",
    component: () => import("@/views/ProcurementDocumentationView.vue"),
    meta: { requiresAuth: true },
    props: true
  },
  {  
    path: "/contracts",
    name: "contracts",
    component: () => import("@/views/ContractsView.vue"),
		children: [
      { path: 'register', component: () => import("@/views/ContractsRegisterView.vue") },
      { path: 'execution', component: () => import("@/views/ContractsExecutionView.vue") },
      { path: 'export', component: () => import("@/views/ContractsExportView.vue") }
    ],
    meta: { requiresAuth: true },
  },
  {
    path: "/catalogDocument",
    name: "catalogDocument",
    component: () => import("@/views/Catalogs/CatalogDocument.vue"),
    meta: { requiresAuth: true, requresAdminOrSpecialistOrOperator: true }
  },
  {
    path: "/catalog",
    name: "catalog",
    component: () => import("@/views/Catalogs/Catalog.vue"),
    meta: { requiresAuth: true, requresAdminOrSpecialistOrOperator: true },
    props: { type: "1", elementName: "метода НЦМД" }
  },
  {
    path: "/catalogRequirements",
    name: "catalogRequirements",
    component: () => import("@/views/Catalogs/Catalog.vue"),
    meta: { requiresAuth: true, requresAdminOrSpecialistOrOperator: true },
    props: { type: "2", elementName: "дополнительного требования" }
  },
	{
    path: "/catalogFinancialResults",
    name: "catalogFinancialResults",
    component: () => import("@/views/Catalogs/Catalog.vue"),
    meta: { requiresAuth: true, requresAdminOrSpecialistOrOperator: true },
		props: { type: "6", elementName: "финансового результата" }
  },
	{
    path: "/catalogInfoAndDocuments",
    name: "catalogInfoAndDocuments",
    component: () => import("@/views/Catalogs/Catalog.vue"),
    meta: { requiresAuth: true, requresAdminOrSpecialistOrOperator: true },
		props: { type: "7", elementName: "дополнительных информации и документов" }
  },	
	{
    path: "/catalogFundingSources",
    name: "catalogFundingSources",
    component: () => import("@/views/Catalogs/Catalog.vue"),
    meta: { requiresAuth: true },
		props: { type: "8", elementName: "источников финансирования" }
  },	
  {
    path: "/catalogDeliveryTerms",
    name: "catalogDeliveryTerms",
    component: () => import("@/views/Catalogs/CatalogServiceExec.vue"),
    meta: { requiresAuth: true, requresAdminOrSpecialistOrOperator: true },
    props: { type: "1", subject_type: '1', elementName: "условия поставки товара" }
  },
  {
    path: "/catalogWorkTerms",
    name: "catalogWorkTerms",
    component: () => import("@/views/Catalogs/CatalogServiceExec.vue"),
    meta: { requiresAuth: true, requresAdminOrSpecialistOrOperator: true },
    props: { type: "1", subject_type: '2', elementName: "условия выполнения работ" }
  },
  {
    path: "/catalogServiceTerms",
    name: "catalogServiceTerms",
    component: () => import("@/views/Catalogs/CatalogServiceExec.vue"),
    meta: { requiresAuth: true, requresAdminOrSpecialistOrOperator: true },
    props: { type: "1", subject_type: '3', elementName: "условия оказания услуг" }
  },
  {
    path: "/catalogExecPlace",
    name: "catalogExecPlace",
    component: () => import("@/views/Catalogs/CatalogServiceExec.vue"),
    meta: { requiresAuth: true },
    props: { type: "2", elementName: "место поставки товара (выполнения работ, оказания услуг)" }
  },
  {
    path: "/catalogMethod",
    name: "catalogMeothod",
    component: () => import("@/views/Catalogs/CatalogMethod.vue"),
    meta: { requiresAuth: true, requresAdminOrSpecialistOrOperator: true }
  },
  {
    path: "/catalogTariffs",
    name: "catalogTariffs",
    component: () => import("@/views/Catalogs/CatalogTariffs.vue"),
    meta: { requiresAuth: true, requresAdminOrSpecialistOrOperator: true }
  },
  {
    path: "/catalogService",
    name: "catalogService",
    component: () => import("@/views/Catalogs/CatalogService.vue"),
    meta: { requiresAuth: true, requresAdminOrSpecialistOrOperator: true }
  },
  {
    path: "/catalogEnsuring",
    name: "catalogEnsuring",
    component: () => import("@/views/Catalogs/CatalogEnsuring.vue"),
    meta: { requiresAuth: true, requresAdminOrSpecialistOrOperator: true }
  },
  {
    path: "/catalogServiceDocument",
    name: "catalogServiceDocument",
    component: () => import("@/views/Catalogs/CatalogServiceDocument.vue"),
    meta: { requiresAuth: true, requresAdminOrSpecialistOrOperator: true }
  },
  {
    path: "/catalogDocumentSubject",
    name: "catalogDocumentSubject",
    component: () => import("@/views/Catalogs/CatalogDocumentSubject.vue"),
    meta: { requiresAuth: true, requresAdminOrSpecialistOrOperator: true }
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("@/views/ProfilePageView.vue"),
    children: [
      { path: 'my', component: () => import("@/views/ProfileView.vue") },
      { path: 'eisSettings', component: () => import("@/views/EisSettingsView.vue") },
      { path: 'companies', component: () => import("@/views/CompaniesView.vue") }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: "/eisPlans",
    name: "eisPlans",
    component: () => import("@/views/EisPlansView.vue"),
    meta: { requiresAuth: true },
    props: true
  },
  {
    path: "/registration",
    name: "registration",
    component: () => import("@/views/RegistrationView.vue"),
    meta: { requiresUnauth: true },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/LoginView.vue"),
    meta: { requiresUnauth: true },
  },
    {
    path: "/expectRegistration",
    name: "expectRegistration",
    component: () => import("@/views/RegistrationOperatorView.vue"),
    meta: { requiresUnauth: true },
  }
];

const router = createRouter({
  history:  createWebHistory(),
  routes,
});

import { useAuthStore } from '@/stores/authStore.js';

router.beforeEach((to, from, next) => {
  const authService = useAuthStore(); 
  const isAuthenticated = authService.isActiveUser

  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login');
  } else if (to.meta.requiresUnauth && isAuthenticated) {
    next('/');
  } else {
    if(to.meta.requresAdminOrSpecialistOrOperator && authService.user.role == 'client')
      next('/');
    next();
  }
});

export default router;
